import React, { useEffect } from "react";
import { Outlet, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useConfig } from "@/hooks/use-config";
import InternalLoginModal from "@/components/internal-login-modal";
import ChatWidgetClient from "@/components/chat-widget";
import { PostLoginTracker } from "@/features/authentication";

export default function RootLayout() {
  const { lng = "ar" } = useParams<{ lng: string }>();
  const { i18n } = useTranslation();
  const config = useConfig();

  useEffect(() => {
    document.documentElement.lang = lng;
    document.documentElement.dir = lng === "en" ? "ltr" : "rtl";
    i18n.changeLanguage(lng);
  }, [lng, i18n]);

  useEffect(() => {
    const { NEXT_PUBLIC_GTM_ID, NEXT_PUBLIC_GTM_ENABLED } = config;
    if (NEXT_PUBLIC_GTM_ENABLED === "true" && NEXT_PUBLIC_GTM_ID) {
      if (document.getElementById("gtm-script")) return;
      const script = document.createElement("script");
      script.id = "gtm-script";
      script.innerHTML = `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
})(window,document,'script','dataLayer','${NEXT_PUBLIC_GTM_ID}');`;
      document.head.appendChild(script);
    }
  }, [config]);

  return (
    <>
      <PostLoginTracker />
      <Outlet />
      <InternalLoginModal />
      <ChatWidgetClient
        locale={lng === "en" ? "en" : "ar"}
        apiUrl={config.AMEEN_URL}
      />
    </>
  );
}
